/** Packages **/
import React from 'react';
import PropTypes from 'prop-types';

const CalendarActivitiesRow = props => (
  <div>
    <div className="Calendar-Activity-Row" style={{ minWidth: props.containerWidth }}>
      {props.activities}
    </div>
  </div>
);

CalendarActivitiesRow.propTypes = {
  activities: PropTypes.array,
  containerWidth: PropTypes.number.isRequired,
};

CalendarActivitiesRow.defaultProps = {
  activities: []
};

export default CalendarActivitiesRow;
